import React, { useState } from "react";
import {
  Drawer,
  Modal,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Button,
  Alert,
  Radio,
  Menu,
  Dropdown,
  Select,
} from "antd";
import ProductTemplate from "./ProductTemplate";

const { Title, Text } = Typography;
const { Option } = Select;

const Cube = ({ selected, num, onClickCube }) => {
  return (
    <div
      onClick={() => onClickCube(num)}
      style={{
        cursor: "pointer",
        paddingTop: 10,
        paddingBottom: 10,
        width: "100%",
        borderRadius: 4,
        backgroundColor: selected ? "#BBD3F7" : "#F1F7FF",
      }}
    >
      <span style={{ display: "flex", justifyContent: "center" }}>{num}</span>
    </div>
  );
};

const SortBox = ({ selected, title1, title2, children }) => {
  <div></div>;
};

export default function DrawerModal({
  visible,
  setDrawerStatus,
  handlePptData,
  uniqueAttrs,
}) {
  const [productPerSlide, setProductPerSlide] = useState(1);
  const [sortOrder, setSortOrder] = useState(1);
  const [customSortOrderValue, setCustomSortOrder] = useState(null);
  const [errorState, showErroState] = useState(false);
  const slides = [1, 2, 3, 4, 5, 6];

  const radioOptions = [
    {
      title1: "Autogenerate",
      title2: "Sorted by category and product ID",
      value: 1,
    },
    {
      title1: "Customize the order of products",
      title2: "Sort the products by",
      value: 2,
    },
  ];
  const onClickCube = (num) => {
    setProductPerSlide(num);
  };

  const onChangeSortOrder = (e) => {
    setSortOrder(e.target.value);
    if (e.target.value === 1) {
      showErroState(false);
    }
  };

  const handleCustomSortOrder = (val) => {
    setCustomSortOrder(val);
    showErroState(false);
  };

  const renderCategoryDropDown = () => {
    return (
      <Select
        style={{ width: 200, marginLeft: 5 }}
        onChange={handleCustomSortOrder}
        value={customSortOrderValue}
        placeholder="Select"
        disabled={sortOrder !== 2}
      >
        {uniqueAttrs.map((item, index) => {
          return (
            <Option key={item} value={item}>
              {item}
            </Option>
          );
        })}
      </Select>
    );
  };

  const renderRadioGroup = () => {
    return (
      <Radio.Group
        onChange={onChangeSortOrder}
        value={sortOrder}
        style={{ display: "flex", flexDirection: "column" }}
      >
        {radioOptions.map((item) => {
          const isSelected = item.value === sortOrder;
          return (
            <Radio
              value={item.value}
              style={{
                padding: 10,
                borderRadius: 4,
                border: isSelected ? "1px solid #8DB5F2" : "1px solid #CDCFCE",
                marginTop: "0.5rem",
                marginBottom: "0.5rem",
                backgroundColor: isSelected ? "#F1F7FF" : "white",
              }}
            >
              <Row style={{ color: "#1D2624" }}>
                <Text>{item.title1}</Text>
              </Row>
              <Row>
                <Text style={{ color: "#4F5655", lineHeight: 2 }}>
                  {item.title2}
                </Text>
                {item.value === 2 && renderCategoryDropDown()}
              </Row>
            </Radio>
          );
        })}
      </Radio.Group>
    );
  };

  const handleDone = () => {
    if (sortOrder === 2 && !customSortOrderValue) {
      showErroState(true);
      return;
    }
    const pptData = {
      products_per_slide: productPerSlide,
      sort_by: sortOrder === 1 ? "category" : customSortOrderValue,
    };
    handlePptData(pptData);
    setDrawerStatus(false);
  };

  const renderButtons = () => {
    return (
      <Row align="bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }}>
        <Col span={12}>
          <Button
            size="large"
            style={{
              color: "#4F5655",
              backgroundColor: "white",
              width: 100,
              border: "1px solid #CDCFCE",
              borderRadius: 4,
            }}
            onClick={() => {
              setDrawerStatus(false);
            }}
          >
            Cancel
          </Button>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            size="large"
            style={{
              color: "white",
              backgroundColor: "#363E3D",
              width: 100,
              border: "1px solid white",
              borderRadius: 4,
            }}
            onClick={handleDone}
          >
            Done
          </Button>
        </Col>
      </Row>
    );
  };

  const renderBody = () => {
    if (productPerSlide !== 1) {
      return (
        <>
          <Text style={{ color: "#4F5655" }}>
            Select the order in which the products get sorted
          </Text>
          {renderRadioGroup()}
          {errorState && (
            <Text style={{ color: "#F57171" }}>Select a field to continue</Text>
          )}
        </>
      );
    }
  };

  return (
    <>
      <Drawer
        width={500}
        placement="right"
        onClose={() => {
          setDrawerStatus(false);
        }}
        visible={visible}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <div>
            <Row>
              <Text
                style={{ marginBottom: "1rem", fontSize: 18, fontWeight: 800 }}
              >
                Choose a template for presentation
              </Text>
            </Row>
            <Text style={{ color: "#4F5655" }}>
              Select the number of products per slide
            </Text>
            <div
              style={{
                marginTop: "1rem",
                display: "flex",
                justifyContent: "space-between",
                borderRadius: 4,
                border: "1px solid #BBD3F7",
                backgroundColor: "#F1F7FF",
              }}
            >
              {slides.map((num) => {
                return (
                  <Cube
                    onClickCube={onClickCube}
                    selected={productPerSlide === num}
                    num={num}
                  />
                );
              })}
            </div>
            <ProductTemplate num={productPerSlide} />
            {renderBody()}
          </div>
          {renderButtons()}
        </div>
      </Drawer>
    </>
  );
}
